export const taskMappings: { [key: string]: string[] } = {
  "Employee Engagement": [
    "Onboarding Survey Form",
    "New Joiners Satisfaction Survey",
    "1:1 Connect",
    "Performance Hygiene Check (Employee)",
    "Performance Hygiene Check (Reporting Manager)",
    "Skip Level / Team Meeting",
    "Engagement Fun Activities",
    "Staffing data",
    "Town Hall",
    "Timesheet"
  ],
  "RMG": [
    "Update & maintain RMG Tracker",
    "Publish a list of people on bench",
    "Match opening & availability"
  ],
  "Off boarding": [
    "Resignation Discussion (TM/ Manager gets connected - Retain/ Accept Resignation)",
    "Maintain offboarding tracker (capture resignation, abscond and release cases)",
    "Conducting Exit interviews",
    "Signing of NOC , Completion Exit Formalities",
    "Processing F & F settlement",
    "Issuance of Relieving & experience letter",
    "Exit employees - BGV clearances through E-mail for their new assignments"
  ],
  "Performance Management": [
    "Send announcement to all about the Annual Appraisal",
    "Appraisal Rating /Feedback collection - TM/ Manager connect for feedback and rating",
    "Final discussion with management",
    "update database on salary change, promotion, change in designations and department etc.",
    "PDP/PIP Action review",
    "Goal Setting"
  ],
  "Grievance Management":[
    "Payroll Query",
    "Attendance Query",
    "Appraisal / Performance Query",
    "Policy Clarification",
    "Leave & Holiday Query",
    "Reimbursement / Expense Claim",
    "Transfer / Relocation Concern",
    "Workplace Facilities / Infrastructure",
    "Manager / Team Concern",
    "Harassment / Misconduct Complaint",
    "Health & Safety Concern",
    "Exit / Resignation Process Query",
    "Training & Development Query",
    "Other (Specify)"
  ]
};